module.exports = "<app-input-field\n  [form]=\"form\"\n  type=\"password\"\n  [id]=\"id\"\n  [controlName]=\"controlName\"\n  [key]=\"key\"\n  [class]=\"class\"\n  [minlength]=\"minlength\"\n  [maxlength]=\"maxlength\"\n  [hideLabel]=\"hideLabel\"\n  [hideErrors]=\"hideErrors\"\n></app-input-field>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-password-field/input-password-field.component.html
// module id = ../../../../../src/app/shared/components/forms/input-password-field/input-password-field.component.html
// module chunks = main